import { Empty, Image } from "antd";
import { Game } from "iconsax-react";
import { IMAGE_URL } from "../../env";

const fallbackAvatar =
  "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMIAAADDCAYAAADQvc6UAAABRWlDQ1BJQ0MgUHJvZmlsZQAAKJFjYGASSSwoyGFhYGDIzSspCnJ3UoiIjFJgf8LAwSDCIMogwMCcmFxc4BgQ4ANUwgCjUcG3awyMIPqyLsis7PPOq3QdDFcvjV3jOD1boQVTPQrgSkktTgbSf4A4LbmgqISBgTEFyFYuLykAsTuAbJEioKOA7DkgdjqEvQHEToKwj4DVhAQ5A9k3gGyB5IxEoBmML4BsnSQk8XQkNtReEOBxcfXxUQg1Mjc0dyHgXNJBSWpFCYh2zi+oLMpMzyhRcASGUqqCZ16yno6CkYGRAQMDKMwhqj/fAIcloxgHQqxAjIHBEugw5sUIsSQpBobtQPdLciLEVJYzMPBHMDBsayhILEqEO4DxG0txmrERhM29nYGBddr//5/DGRjYNRkY/l7////39v///y4Dmn+LgeHANwDrkl1AuO+pmgAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAwqADAAQAAAABAAAAwwAAAAD9b/HnAAAHlklEQVR4Ae3dP3PTWBSGcbGzM6GCKqlIBRV0dHRJFarQ0eUT8LH4BnRU0NHR0UEFVdIlFRV7TzRksomPY8uykTk/zewQfKw/9znv4yvJynLv4uLiV2dBoDiBf4qP3/ARuCRABEFAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghgg0Aj8i0JO4OzsrPv69Wv+hi2qPHr0qNvf39+iI97soRIh4f3z58/u7du3SXX7Xt7Z2enevHmzfQe+oSN2apSAPj09TSrb+XKI/f379+08+A0cNRE2ANkupk+ACNPvkSPcAAEibACyXUyfABGm3yNHuAECRNgAZLuYPgEirKlHu7u7XdyytGwHAd8jjNyng4OD7vnz51dbPT8/7z58+NB9+/bt6jU/TI+AGWHEnrx48eJ/EsSmHzx40L18+fLyzxF3ZVMjEyDCiEDjMYZZS5wiPXnyZFbJaxMhQIQRGzHvWR7XCyOCXsOmiDAi1HmPMMQjDpbpEiDCiL358eNHurW/5SnWdIBbXiDCiA38/Pnzrce2YyZ4//59F3ePLNMl4PbpiL2J0L979+7yDtHDhw8vtzzvdGnEXdvUigSIsCLAWavHp/+qM0BcXMd/q25n1vF57TYBp0a3mUzilePj4+7k5KSLb6gt6ydAhPUzXnoPR0dHl79WGTNCfBnn1uvSCJdegQhLI1vvCk+fPu2ePXt2tZOYEV6/fn31dz+shwAR1sP1cqvLntbEN9MxA9xcYjsxS1jWR4AIa2Ibzx0tc44fYX/16lV6NDFLXH+YL32jwiACRBiEbf5KcXoTIsQSpzXx4N28Ja4BQoK7rgXiydbHjx/P25TaQAJEGAguWy0+2Q8PD6/Ki4R8EVl+bzBOnZY95fq9rj9zAkTI2SxdidBHqG9+skdw43borCXO/ZcJdraPWdv22uIEiLA4q7nvvCug8WTqzQveOH26fodo7g6uFe/a17W3+nFBAkRYENRdb1vkkz1CH9cPsVy/jrhr27PqMYvENYNlHAIesRiBYwRy0V+8iXP8+/fvX11Mr7L7ECueb/r48eMqm7FuI2BGWDEG8cm+7G3NEOfmdcTQw4h9/55lhm7DekRYKQPZF2ArbXTAyu4kDYB2YxUzwg0gi/41ztHnfQG26HbGel/crVrm7tNY+/1btkOEAZ2M05r4FB7r9GbAIdxaZYrHdOsgJ/wCEQY0J74TmOKnbxxT9n3FgGGWWsVdowHtjt9Nnvf7yQM2aZU/TIAIAxrw6dOnAWtZZcoEnBpNuTuObWMEiLAx1HY0ZQJEmHJ3HNvGCBBhY6jtaMoEiJB0Z29vL6ls58vxPcO8/zfrdo5qvKO+d3Fx8Wu8zf1dW4p/cPzLly/dtv9Ts/EbcvGAHhHyfBIhZ6NSiIBTo0LNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiEC/wGgKKC4YMA4TAAAAABJRU5ErkJggg==";

interface Props {
  list?: any;
}

const TabVoucher: React.FC<Props> = (props) => {
  const { list } = props;
  return (
    <>
      {list.length === 0 ? (
        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} className="rs-empty" />
      ) : (
        <div className="list-normal">
          {list.map((item: any) => (
            <div className="one-item pb-16px t-fz-12px" key={item.id}>
              <div className="left">
                <Game size="24" color="#999999" variant="Bulk" />
              </div>
              <div className="right">
                <div className="title cl-E5E5E5">{item.timecashout}</div>
                <div className="item-jcsb">
                  <div className="label">Match</div>
                  <div className="price t-fz-14px">
                    {item.match_customer_plans}$
                  </div>
                </div>
                <div className="item-jcsb">
                  <div className="label">Cash-out</div>
                  <div className="price t-fz-14px">{item.match_amount}$</div>
                </div>
                <div className="item-jcsb">
                  <div className="label">Staff Match</div>
                  <div className="price t-fz-14px cl-999999">
                    {item.staff_name}
                  </div>
                </div>
                <div className="item-jcsb">
                  <div className="label">Shift</div>
                  <div className="price t-fz-14px cl-999999">{item.shift}</div>
                </div>
                <div className="item-jcsb">
                  <div className="label">Machine</div>
                  <div className="price t-fz-14px cl-999999">
                    {item.machine_number}
                  </div>
                </div>
                <div className="item-jcsb">
                  <div className="label">Image proof</div>
                  <div className="price t-fz-14px"></div>
                </div>
                {/* <div className="img-box">
                        <img src="/images/img-voucher.png" alt="voucher" />
                      </div> */}
                {item.photo_url ? (
                  <Image
                    width={270}
                    src={`${item.photo_url}`}
                    preview={{
                      src: `${item.photo_url}`,
                    }}
                    fallback={fallbackAvatar}
                    // style={{ borderRadius: '50%', overflow: 'hidden' }}
                  />
                ) : (
                  <Empty
                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                    className="rs-empty"
                  />
                )}
                <div className="item-jcsb" style={{ marginBlockStart: 12 }}>
                  <div className="label">Image match</div>
                  <div className="price t-fz-14px"></div>
                </div>
                {/* <div className="img-box">
                        <img src="/images/img-voucher.png" alt="voucher" />
                      </div> */}
                {item.image_match ? (
                  <Image
                    width={270}
                    src={`${IMAGE_URL}${item.image_match}`}
                    preview={{
                      src: `${IMAGE_URL}${item.image_match}`,
                    }}
                    fallback={fallbackAvatar}
                    // style={{ borderRadius: '50%', overflow: 'hidden' }}
                  />
                ) : (
                  <Empty
                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                    className="rs-empty"
                  />
                )}
              </div>
            </div>
          ))}

          {/* <div className="one-item pb-16px t-fz-12px">
                <div className="left"><Game size="24" color="#999999" variant="Bulk" /></div>
                <div className="right">
                  <div className="title cl-E5E5E5">06:41 pm 03/31/2024</div>
                  <div className="item-jcsb">
                    <div className="label">Match</div>
                    <div className="price t-fz-14px">40$</div>
                  </div>
                  <div className="item-jcsb">
                    <div className="label">Cash-out</div>
                    <div className="price t-fz-14px">500$</div>
                  </div>
                  <div className="item-jcsb">
                    <div className="label">Staff Match</div>
                    <div className="price t-fz-14px cl-999999">Johny Tien</div>
                  </div>
                  <div className="item-jcsb">
                    <div className="label">Shift</div>
                    <div className="price t-fz-14px cl-999999">1</div>
                  </div>
                  <div className="item-jcsb">
                    <div className="label">Machine</div>
                    <div className="price t-fz-14px cl-999999">23</div>
                  </div>
                  <div className="item-jcsb">
                    <div className="label">Image proof</div>
                    <div className="price t-fz-14px"></div>
                  </div>
                  <div className="img-box">
                    <img src="/images/img-voucher.png" alt="voucher" />
                  </div>
                  <div className="item-jcsb" style={{ marginBlockStart: 12 }}>
                    <div className="label">Image match</div>
                    <div className="price t-fz-14px"></div>
                  </div>
                  <div className="img-box">
                    <img src="/images/img-voucher.png" alt="voucher" />
                  </div>
                </div>
              </div>

              <div className="one-item pb-16px t-fz-12px">
                <div className="left"><Game size="24" color="#999999" variant="Bulk" /></div>
                <div className="right">
                  <div className="title cl-E5E5E5">06:41 pm 03/31/2024</div>
                  <div className="item-jcsb">
                    <div className="label">Match</div>
                    <div className="price t-fz-14px">40$</div>
                  </div>
                  <div className="item-jcsb">
                    <div className="label">Cash-out</div>
                    <div className="price t-fz-14px">500$</div>
                  </div>
                  <div className="item-jcsb">
                    <div className="label">Staff Match</div>
                    <div className="price t-fz-14px cl-999999">Johny Tien</div>
                  </div>
                  <div className="item-jcsb">
                    <div className="label">Shift</div>
                    <div className="price t-fz-14px cl-999999">1</div>
                  </div>
                  <div className="item-jcsb">
                    <div className="label">Machine</div>
                    <div className="price t-fz-14px cl-999999">23</div>
                  </div>
                  <div className="item-jcsb">
                    <div className="label">Image proof</div>
                    <div className="price t-fz-14px"></div>
                  </div>
                  <div className="img-box">
                    <img src="/images/img-voucher.png" alt="voucher" />
                  </div>
                  <div className="item-jcsb" style={{ marginBlockStart: 12 }}>
                    <div className="label">Image match</div>
                    <div className="price t-fz-14px"></div>
                  </div>
                  <div className="img-box">
                    <img src="/images/img-voucher.png" alt="voucher" />
                  </div>
                </div>
              </div> */}
        </div>
      )}
    </>
  );
};

export default TabVoucher;
